<template>
  <collapse v-model="selected" class="work-time-collapse">
    <collapse-panel v-for="g in groups" :key="g.day" :name="g.day">
      {{ get_week_name(g.day) }}
      <div slot="content" class="work-time-collapse__content">
        <i-button-group v-for="item in g.items" :key="item.id" class="work-time-content__item">
          <i-button class="work-time-item__time">{{ item.start }} - {{ item.end }}</i-button>
          <i-button icon="md-close" @click="remove(item)" />
        </i-button-group>
      </div>
    </collapse-panel>
  </collapse>
</template>

<script>
  import cloneDeep from 'lodash-es/cloneDeep';
  import { groupByDay } from '@pbx/helpers/time-conditions/work-time';

  export default {
    props: {
      value: {
        type: Array,
        default: () => []
      },
      with_id: {
        type: Boolean,
        default: true
      }
    },

    data: () => ({
      selected: null
    }),

    computed: {
      groups: function () {
        return groupByDay(this.value);
      }
    },

    methods: {
      get_week_name(day) {
        if (isNaN(day)) {
          return this.$t(`shared.unit.day.${day}.full`);
        } else {
          const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
          return this.$t(`shared.unit.day.${days[day]}.full`);
        }
      },
      remove: function (item) {
        let result;
        if (this.with_id) {
          result = cloneDeep(this.value).filter((i) => i.id !== item.id);
        } else {
          result = cloneDeep(this.value).filter((i) => i.day + i.start !== item.day + item.start);
        }
        this.$emit('input', result);
      }
    }
  };
</script>

<style lang="scss">
  .work-time-collapse {
    &__content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

  .work-time-content {
    &__item {
      font-size: 12px;
      margin-bottom: 10px;
      display: flex;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .work-time-item {
    &__time {
      font-size: 12px;

      &:hover,
      &:focus,
      &:active {
        background-color: $grey-light;
        border-color: $grey-dark;
        color: $text-color;
        cursor: default;
        box-shadow: none;
      }
    }
  }
</style>
